/* eslint-disable sort-keys */
var htmlEntityMap = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;"
};
var nonLineBreakRegEx = /[&<>"']/g;
var replaceEntity = function (c) { return htmlEntityMap[c] || c; };
// must match lodestar's ctaLink color
var defaultAnchorStyle = "text-decoration:underline; cursor:pointer; color:#0970be;";
var StringUtil = /** @class */ (function () {
    function StringUtil() {
    }
    /**
     * This method will convert a string to html including replacing links and line breaks.
     *
     * @param inString - A string (UNSAFE HTML) which may contain one or more url links and is intended for presentation in the UI.
     * @param anchorStyle - (optional) An inline style value that will be used for any generated anchor tags
     *
     * @return A string (SAFE HTML) which has had any url links packaged as <a> tags. Line breaks have been replaced with <br>.
     * Any unsafe HTML has been safely escaped.
     */
    StringUtil.toHtmlWithLinks = function (inString, anchorStyle) {
        if (this.containsLink(inString)) {
            // replace links < & >
            inString = StringUtil.parseLinks(inString, anchorStyle);
            // then replace line breaks
            return inString.replace(/\n/g, "<br>");
        }
        else {
            return StringUtil.toHtml(inString);
        }
    };
    /**
     * This method is used to convert data to safe HTML for display within our UI
     * (i.e. information that is placed in the innerHTML of a div that is not editable)
     *
     * Note: This does not convert "\n" to <br>
     */
    StringUtil.toHtml = function (inString) {
        if (inString == undefined || inString.length < 1) {
            return "";
        }
        return inString.replace(nonLineBreakRegEx, replaceEntity);
    };
    /**
     * This method is used to determine if a string is a link
     * @param inString
     */
    StringUtil.isLink = function (inString) {
        if (/^(http:\/\/|https:\/\/|www\.)([a-zA-Z0-9._-]+)(:[0-9]+)?(\/[^?\s'"<>]*)*(\?[^\s'"<>]*)?$/i.test(inString)) {
            return true;
        }
        if (/^(sip:)([0-9]+)$/i.test(inString)) {
            return true;
        }
        return false;
    };
    /**
     * This method is used to determine if a string contains a link
     * @param inString
     */
    StringUtil.containsLink = function (inString) {
        // eslint-disable-next-line
        return /\b(sip:)([0-9]+)\b|\b((https?:\/\/|www\.)([a-zA-Z0-9!#$%&'*+-\/=?_`{|}~]+(:[^ @:]+)?@)?((([a-zA-Z0-9\-_]{1,255}|xn--[a-zA-Z0-9\-]+)\.)+(xn--[a-zA-Z0-9\-]+|[a-zA-Z]{2,63}|\d{1,3})|(%[0-9a-fA-F]{2})+|[0-9]+)(:[0-9]{1,5})?([\/?][^ \s\/,]*)*)/i.test(inString);
    };
    /**
     * This method is used to take a string of user input and prepare any web links for html presentation
     *
     * This is expensive logic. Should call containsLink to check if string already has link before attempting to parse
     *
     * @param inString - A string (UNSAFE HTML) which contains one or more url links and is intended for presentation in the UI.
     * @param anchorStyle - An inline style value that will be used for any generated anchor tags. If not specified, we use a
     *              default style of 'text-decoration:underline; cursor:pointer; color:#0970be;'. If null, no style is set.
     * @return A string (SAFE HTML) which has had any url links packaged as <a> tags.  Any unsafe HTML has been safely escaped.
     */
    StringUtil.parseLinks = function (inString, anchorStyle) {
        if (anchorStyle === void 0) { anchorStyle = defaultAnchorStyle; }
        var dataSet = [];
        // split on new lines
        var lineSet = inString.split("\n");
        var setSize = lineSet.length;
        for (var i = 0; i < setSize; i++) {
            var lineSetValue = lineSet[i];
            if (lineSetValue.length == 0) {
                dataSet.push("\n");
            }
            else {
                if (i != 0) {
                    dataSet.push("\n");
                }
                var wordSet = lineSetValue.split(" ");
                for (var j = 0; j < wordSet.length; j++) {
                    var wordSetValue = wordSet[j];
                    if (wordSetValue.length == 0) {
                        dataSet.push(" ");
                    }
                    else {
                        if (j != 0) {
                            dataSet.push(" ");
                        }
                        dataSet.push(wordSetValue);
                    }
                }
            }
        }
        var resultBuf = [];
        var linkRegex = /\b(sip:)([0-9]+)\b|\b((https?:\/\/|www\.)([a-zA-Z0-9!#$%&'*+-\/=?_`{|}~]+(:[^ @:]+)?@)?((([a-zA-Z0-9\-_]{1,255}|xn--[a-zA-Z0-9\-]+)\.)+(xn--[a-zA-Z0-9\-]+|[a-zA-Z]{2,63}|\d{1,3})|(%[0-9a-fA-F]{2})+|[0-9]+)(:[0-9]{1,5})?([\/?][^ \s\/,]*)*)/gim; // eslint-disable-line
        for (var i = 0; i < dataSet.length; i++) {
            var dataSetValue = dataSet[i];
            var endOfLastMatch = 0;
            var matchResults = linkRegex.exec(dataSetValue);
            while (matchResults != null) {
                // Take the part of the current string that did not match the URL regex pattern and emit it as plain text. Then
                // add an <a> tag around the current URL match.
                resultBuf.push(StringUtil.toHtml(dataSetValue.substr(endOfLastMatch, matchResults.index - endOfLastMatch)));
                var matchedUrl = matchResults[0];
                endOfLastMatch = linkRegex.lastIndex;
                resultBuf.push('<a rel="noopener noreferrer" href="');
                if (!/(^http|^sip)/i.test(matchedUrl)) {
                    resultBuf.push("http://");
                }
                resultBuf.push(StringUtil.toHtml(matchedUrl));
                resultBuf.push('" target="_blank"');
                resultBuf.push(' tabindex="-1"');
                resultBuf.push(' ondragstart="return false;"');
                if (anchorStyle) {
                    resultBuf.push(' style="');
                    resultBuf.push(anchorStyle);
                    resultBuf.push('"');
                }
                resultBuf.push(">");
                resultBuf.push(StringUtil.toHtml(matchedUrl));
                resultBuf.push("</a>");
                matchResults = linkRegex.exec(dataSetValue);
            }
            // handle any character after the matched url but before the next whitespace
            resultBuf.push(StringUtil.toHtml(dataSetValue.substr(endOfLastMatch)));
        }
        return resultBuf.join("");
    };
    return StringUtil;
}());
export { StringUtil };
//# sourceMappingURL=StringUtil.js.map